<template>
  <v-tooltip bottom>
    <v-menu
      slot="activator"
      :close-on-content-click="false"
      offset-y
      left
    >
      <v-btn icon slot="activator">
        <v-icon class="text--secondary">{{ headers.some(elem => !elem.show) ? 'settings_suggest' : 'settings' }}</v-icon>
      </v-btn>

      <v-card>
        <v-list>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('Table settings') }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ $t('Select visible columns') }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile v-for="(header, key) in headers" :key="key" v-if="header.value != 'actions'" @click.stop="header.show = !header.show" :disabled="isDisabled(header)">
            <v-list-tile-action>
              <v-switch :input-value="header.show" color="purple" :disabled="isDisabled(header)"></v-switch>
            </v-list-tile-action>
            <v-list-tile-title>{{ header.text }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>
    <span>{{ $t('Table settings') }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: ['headers'],
  data() {
    return {
    }
  },
  methods: {
    isDisabled(header) {
      return header.persistent
          || header.show && this.headers.filter(elem => !elem.persistent && elem.show).length < 2;
    }
  }
}
</script>